import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import clsx from 'clsx';
import styles from './RemoveAdjustmentDialog.style';
import RemovingIndicator from '../../components/RemovingIndicator';
import appStyles from '../../App.style';

const RemoveAdjustmentDialog = ({
  onDismiss,
  onSubmit,
  adjustmentId,
  error,
  isRemoving,
  isOpen,
  className,
  ...other
}) => (
  <Dialog
    dialogContentProps={{
      type: DialogType.normal,
      title: 'Remove Adjustment',
      closeButtonAriaLabel: 'Close',
    }}
    deleteError={error}
    modalProps={{
      className: clsx(styles.root, className),
    }}
    hidden={!isOpen}
    onDismiss={onDismiss}
    onSubmit={onSubmit}
    isSubmitting={isRemoving}
    {...other}
  >
    <p>
      Deleted adjustments cannot be recovered. Do you wish to continue?
      <br />
      <br />
    </p>
    {error && (
      <span className={clsx(styles.secondaryIcon, appStyles.defaultColor)}>{error.message}</span>
    )}
    <DialogFooter>
      <DefaultButton onClick={onDismiss} disabled={isRemoving}>
        Cancel
      </DefaultButton>
      <PrimaryButton type="submit" onClick={onSubmit} disabled={isRemoving}>
        Delete
      </PrimaryButton>

      {isRemoving && <RemovingIndicator className={styles.saving} />}
    </DialogFooter>
  </Dialog>
);

RemoveAdjustmentDialog.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  adjustmentId: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isOpen: PropTypes.bool,
  isRemoving: PropTypes.bool,
  className: PropTypes.string,
  error: PropTypes.object,
};

RemoveAdjustmentDialog.defaultProps = {
  adjustmentId: '',
  isSubmitting: false,
  isOpen: false,
  isRemoving: false,
  className: 'normal',
  error: undefined,
};

export default RemoveAdjustmentDialog;
